export default __webpack_public_path__ + "static/media/delete_icon.09f56512.svg";